// #region imports

// --- Angular
import { Component, OnInit } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
